import {Injectable} from '@angular/core';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {DriverExpenses, IDriverExpenses} from 'app/blocks/model/driver-expenses';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {SERVER_API_URL} from 'app/app.constants';
import {Observable} from 'rxjs';
import {IImage} from 'app/blocks/model/image.model';

@Injectable({
    providedIn: 'root'
})
export class DriverExpensesService extends EntityCrudService<IDriverExpenses> {
    constructor(http: HttpClient) {
        super(http, Resource.EXPENSES, (obj?) => new DriverExpenses(obj));
    }

    public downloadPDF = (expenseId: number): any => {
        const REQUEST_URI = `${SERVER_API_URL}api/expenses/${expenseId}/pdf`;
        return this.http.get(REQUEST_URI, {responseType: 'arraybuffer'});
    };

    public getExpenseImages = (expenseId: number): Observable<IImage[]> => {
        const REQUEST_URI = `${SERVER_API_URL}api/expenses/${expenseId}/images`;
        return this.http.get<IImage[]>(REQUEST_URI);
    };

    /** Clears the posted flag so the expenses can be posted to the accounting package again. */
    public markAsNotPosted = (expenseIds: number[]): Promise<void> => {
        const REQUEST_URI = `${SERVER_API_URL}api/expenses/mark-as-not-posted`;
        return this.http.put<void>(REQUEST_URI, null, {params: {ids: expenseIds.join(',')}}).toPromise();
    };
}
